import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const accrualANZApi = {
    getAccrualANZById: (id: number): Observable<Dtos.GetAccrualANZByIdResponse> => {
        //Create the request.
        let request: Dtos.GetAccrualANZById = new Dtos.GetAccrualANZById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetAccrualANZByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getAccrualANZByTrialId: (trialId: number): Observable<Dtos.GetAccrualANZByTrialIdResponse> => {
        //Create the request.
        let request: Dtos.GetAccrualANZByTrialId = new Dtos.GetAccrualANZByTrialId();

        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.GetAccrualANZByTrialIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}